import { useEffect, useState } from "react";

const KEY = "sv_cookie_consent";
const EVT = "sv-consent-change";

export const getConsent = () => {
  try { return localStorage.getItem(KEY); } catch { return null; }
};

export const setConsent = (value) => {
  try { localStorage.setItem(KEY, value); } catch {}
  window.dispatchEvent(new Event(EVT));
};

export const resetConsent = () => {
  try { localStorage.removeItem(KEY); } catch {}
  window.dispatchEvent(new Event(EVT));
};

export function useConsent() {
  const [value, setValue] = useState(getConsent());
  useEffect(() => {
    const on = () => setValue(getConsent());
    window.addEventListener(EVT, on);
    return () => window.removeEventListener(EVT, on);
  }, []);
  return value;
}
